import { useReveal } from '../hooks/UseReveal';
import { useState, useEffect } from "react";

import SpecialText from '../fragments/SpecialText';
import SmartLink from '../fragments/SmartLink';

export default function Jobs({ block }) {

    const contentRevealRef = useReveal({ once: true });

    return (
        <div id={block.section_id} className={`c-page__block c-page__block--jobs`}>
            <div className={`l-grid l-grid--xs-even c-jobs c-transition-in`} ref={contentRevealRef}>
                <div className={`c-jobs__left l-grid__col l-grid__col--m-4-12 l-grid__col--l-3-12`} >
                    {block.heading && (
                        <h3 className="c-jobs__heading c-heading l-bottom-space">
                            <SpecialText text={block.heading || 'Join Our Team'} />
                        </h3>
                    )}
                    {block.text && (
                        <div className="scope-text c-jobs__text l-bottom-mobile-space" dangerouslySetInnerHTML={{ __html: block.text || '' }} />
                    )}
                </div>
                <div className={`c-jobs__right l-grid__col l-grid__col--m-7-12 l-grid__col--m-push-1-12 l-grid__col--l-8-12`}>
                    {block.jobs && block.jobs.length > 0 ? (
                        <>
                            {block.jobs.map((job, index) => (
                                <SmartLink link={job.url} key={index} className="c-jobs__item">
                                    {job.title && (
                                        <h3 className="c-jobs__item__title c-paragraph c-paragraph--medium" dangerouslySetInnerHTML={{ __html: job.title }} />
                                    )}
                                    {job.details && (
                                        <p className="c-jobs__item__details c-paragraph c-paragraph--faded" dangerouslySetInnerHTML={{ __html: job.details }} />
                                    )}
                                    <svg viewBox="0 0 22 10"><polygon points="16.93 .91 16.25 1.64 19.33 4.5 0 4.5 0 5.5 19.33 5.5 16.25 8.36 16.93 9.09 21.33 5 16.93 .91" /></svg>
                                </SmartLink>
                            ))}
                        </>
                    ) : (
                        <div className="c-jobs__item">
                            <h3 className="c-jobs__list__item__title" dangerouslySetInnerHTML={{ __html: 'No job listings available at the moment.' }} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}